import { factory, getResponseCamelization } from '@repo-level/core-front';
import { TournamentBackend } from 'api/tournaments';
import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupParams,
  CMSImageBase,
  CMSOrder,
  getResponseCMS,
  LIMIT_500,
} from './base';
import { isCMSV3 } from 'helpers/conf';

export interface TournamentBanner {
  prizePool: string;
  title: string;
  minBet?: string;
  minSpins?: string;
  background: CMSImageBase;
  image: CMSImageBase;
  durationFrom: string;
  durationTo: string;
}

export interface HowToWinCard {
  description: string;
  id: number;
  title: string;
}

export interface Tournament extends CMSApiBase, CMSOrder, CMSGroupParams {
  name: string;
  banner: TournamentBanner;
  tc: string;
  collectionName: string;
  backendTournamentId?: string;
  externalWidgetId?: string;
  ssWidgetId?: string;
  cards: HowToWinCard[];
  text?: string;
  icon?: CMSImageBase;
  backendTournament?: TournamentBackend | undefined;
}

export const tournamentsV3 = factory((r) => (lang: string) =>
  r<Tournament[]>(
    'get',
    buildCmsUrl({ path: 'tournaments', lang, limit: LIMIT_500 })
  )
);

export const tournamentsV4 = factory((r) => (lang: string) =>
  r<Tournament[]>(
    'get',
    buildCmsUrl({
      path: 'tournaments',
      lang,
      limit: LIMIT_500,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const tournaments = isCMSV3 ? tournamentsV3 : tournamentsV4;

export interface TournamentGames {
  tournamentGameIds: string;
  tournamentGameCategories: string;
}

export const tournamentGamesV3 = factory((r) => () =>
  r<TournamentGames>('get', buildCmsUrl({ path: 'tournament-games' }))
);

export const tournamentGamesV4 = factory((r) => () =>
  r<TournamentGames>(
    'get',
    buildCmsUrl({ path: 'tournament-game' }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const tournamentGames = isCMSV3 ? tournamentGamesV3 : tournamentGamesV4;
